import { Component, OnInit } from '@angular/core';

import { Categoria } from "../shared/categoria.model";
import { categoriasModuleName } from "../shared/data.service";
import { CategoriaApiService } from "../shared/categoria-api.service";
import {CategoriaNavigationService} from "../shared/categoria-navigation.service";
import {UtilService} from "../../../shared/services/util.service";

@Component({
  template: require('./categoria-list.component.html'),
  styles: [require('./categoria-list.component.css')]
})
export class CategoriaListComponent implements OnInit {
  list: Categoria[] = [];
  loading: boolean = true;
  showDisabled: boolean = false;
  categoriasModuleName: any = categoriasModuleName;

  constructor(
    private _categoriaApiService: CategoriaApiService,
    private _categoriaNavigationService: CategoriaNavigationService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._categoriaNavigationService.goToNew();
  }

  clickEdit(item: Categoria) {
    this._categoriaNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Categoria) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    if (item.id === 1 || item.id === 2 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6) {
      swal("Aviso!", "Não é possível excluir esta categoria", "warning");
    } else {
      this._utilService.swalMessageDelete(onDelete);  
    }    
  }

  private getAll() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.list = Response;
      }
      this.loading = false;
    }.bind(this));

    this._categoriaApiService.onGetAll(onDone);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._categoriaApiService.onDelete(item.id, onDone);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/categorias/categoria-list/categoria-list.component.ts
 **/